import React, { FC } from 'react';
import { WithWizard } from 'react-albus';
import { FormattedMessage } from 'react-intl';
import { StepId } from './steps';
import { ImportTitle } from './types';

const StepTitle: FC<{ id: StepId } & ImportTitle> = ({ id, title }) => {
  switch (id) {
    case 'Step1':
      return title ?? <FormattedMessage id="projects.phase.import" />;
    case 'Step2':
      return <FormattedMessage id="projects.phase.import.step2.title" />;
    default:
      return null;
  }
};

export const Title: FC<ImportTitle> = ({ title }) => {
  return (
    <WithWizard
      render={({ step }) => <StepTitle id={step.id as StepId} title={title} />}
    />
  );
};
